/**
 * Customer-facing banner shown on the workspace when the estimate is
 * in INFO_REQUESTED. Tells the customer their contractor is waiting
 * on a reply.
 */

interface Props {
  show: boolean;
}

export function ActionNeededBanner({ show }: Props) {
  if (!show) return null;
  return (
    <section
      role="alert"
      className="mb-6 rounded-xl border-2 border-blue-300 bg-blue-50 p-5 shadow-sm"
    >
      <div className="flex items-start gap-3">
        <span
          aria-hidden="true"
          className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-200 text-base font-bold text-blue-900"
        >
          !
        </span>
        <div>
          <h3 className="font-serif text-lg text-starz-navy">
            Action needed: please answer your contractor's question
          </h3>
          <p className="mt-1 text-sm text-starz-charcoal">
            Scroll down to the chat and reply so we can finish your estimate.
          </p>
        </div>
      </div>
    </section>
  );
}
